<template>
  <div data-cy="time-display" class="text-label">{{ formattedTime }}</div>
</template>
<script setup lang="ts">
import { useInterval } from "@vueuse/core";
import { storeToRefs } from "pinia";
import { computed } from "vue";

import { useCallsStore } from "@/stores/calls";

const { callStartedAt } = storeToRefs(useCallsStore());

const { counter: tick } = useInterval(1_000, { controls: true });

const formattedTime = computed(() => {
  void tick.value;
  if (!callStartedAt.value) {
    return "00:00";
  }
  const elapsed = Math.floor((Date.now() - callStartedAt.value) / 1_000);
  return new Date(Math.max(0, elapsed) * 1_000).toISOString().slice(14, 19);
});
</script>
